<script>
import { lookupPincode } from '@/utils/pincode';

export default {
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: 'Pincode' },
    error: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'resolved'],
  methods: {
    onInput(e) {
      const value = e.target.value;
      this.$emit('update:modelValue', value);
      this.fetchDetails(value);
    },
    async fetchDetails(value) {
      const result = await lookupPincode(value);
      if (result) this.$emit('resolved', result);
    },
  },
};
</script>

<template>
  <div>
    <label class="form-label">{{ label }}</label>
    <input
      type="text"
      class="form-control"
      :value="modelValue"
      maxlength="6"
      placeholder="6 digits"
      @input="onInput"
    />
    <div v-if="error" class="text-danger small mt-1">{{ error }}</div>
  </div>
</template>